import "@/services/airbrake";
import "@/services/datadog";

import "@/services/cookiebot";

import "@/modules/auth";
import "@/modules/wds";
import { trackUTMParams } from "@/modules/utm-params-tracking";

import initCookieBanner from "@/features/cookie-banner/init";

initCookieBanner();

trackUTMParams();
